// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 3L14.7365 9.2635L21 12L14.7365 14.7365L12 21L9.2635 14.7365L3 12L9.2635 9.2635L12 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3L14.7365 9.2635L21 12L14.7365 14.7365L12 21L9.2635 14.7365L3 12L9.2635 9.2635L12 3Z","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M21.125 4L21.1665 4.08346L21.25 4.125L21.1665 4.16654L21.125 4.25L21.0835 4.16654L21 4.125L21.0835 4.08346L21.125 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19.75 18L20.3316 19.1684L21.5 19.75L20.3316 20.3316L19.75 21.5L19.1684 20.3316L18 19.75L19.1684 19.1684L19.75 18Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Filter3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-3',
    ref,
    icon: element,
  },
));

Filter3Icon.displayName = 'Filter3Icon';

export default Filter3Icon;
